import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { InvoiceReportNoValueNotesResult } from "src/app/models/Invoice/invoice-report-no-value-notes-result";
import { InvoiceReportSummaryResult } from "src/app/models/Invoice/invoice-report-summary-result";
import { InvoiceReportValueNotesResult } from "src/app/models/Invoice/invoice-report-value-notes-result";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  private apiUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) {
  }

  async invoiceReportSummaryPromise(year: string, month: string): Promise<InvoiceReportSummaryResult[]> {
    try {
      return await lastValueFrom(this.httpClient.get<InvoiceReportSummaryResult[]>(`${this.apiUrl}/api/invoice/summary/${year}/${month}`));
    } catch (error: unknown) {
      const err = this.toError('InvoiceService.invoiceReportSummaryPromise failed', error);
      console.error(err.message, error);
      throw err;
    }
  }

  async invoiceReportValueNotesPromise(year: string, month: string): Promise<InvoiceReportValueNotesResult[]> {
    try {
      return await lastValueFrom(this.httpClient.get<InvoiceReportValueNotesResult[]>(`${this.apiUrl}/api/invoice/value/notes/${year}/${month}`));
    } catch (error: unknown) {
      const err = this.toError('InvoiceService.invoiceReportValueNotesPromise failed', error);
      console.error(err.message, error);
      throw err;
    }
  }

  async invoiceReportNoValueNotesPromise(year: string, month: string): Promise<InvoiceReportNoValueNotesResult[]> {
    try {
      return await lastValueFrom(this.httpClient.get<InvoiceReportNoValueNotesResult[]>(`${this.apiUrl}/api/invoice/novalue/notes/${year}/${month}`));
    } catch (error: unknown) {
      const err = this.toError('InvoiceService.invoiceReportNoValueNotesPromise failed', error);
      console.error(err.message, error);
      throw err;
    }
  }

  private toError(context: string, error: unknown): Error & { status?: number } {
    const status = (error instanceof Object && 'status' in error)
      ? (error as { status: number }).status
      : undefined;

    const message = (error instanceof Error)
      ? error.message
      : String(error);

    const enriched = new Error(`${context}: ${message}`) as Error & { status?: number };
    enriched.status = status;
    return enriched;
  }

}